import { useDispatch, useSelector } from 'react-redux'
import { ROUTE_SEO_GEOENTITY } from '../../../routes'
import { TAG_CLICK_MY_MAP } from '../../analytics/analytics.tagids.constants'
import { resetGeoentityList } from '../../../store/geoentity/geoentitySlice'
import { navigateTo } from '../../../store/history/history.actions'
import { LAYER_ID_CMM, MAP_STATUS_STYLED } from '../../../store/map/map.constants'
import { selectMapStatus } from '../../../store/map/map.selectors'
import { selectIsFrenchSite } from '../../../store/navigation/navigation.selectors'
import useConfigureAndSendTag from '../../analytics/useConfigureAndSendTag'
import { useAction } from '../../utils/react-redux'
import { useEffectWithMapContext } from '../MapContext'

const useClickMyMapLayers = () => {
  const status = useSelector(selectMapStatus)
  const execNavigateTo = useAction(navigateTo)
  const configureAndSendTag = useConfigureAndSendTag()
  const dispatch = useDispatch()
  const isFrenchSite = useSelector(selectIsFrenchSite)

  const navigateToPoi = ({ id, rubricId }) => {
    configureAndSendTag({
      type: TAG_CLICK_MY_MAP,
      tagInfo: {
        catId: rubricId
      }
    })

    dispatch(resetGeoentityList())
    execNavigateTo({
      route: ROUTE_SEO_GEOENTITY,
      routeOptions: { geoentityId: id }
    })
  }

  const handleClick = e => {
    if (e.handled) return
    e.handled = true
    const id = e.features[0].properties.mappy_poi_id
    const rubricId = e.features[0].properties.mappy_context_rubric

    navigateToPoi({ id, rubricId })
  }

  useEffectWithMapContext(
    map => {
      if (!map.getStyle() || status !== MAP_STATUS_STYLED) return

      map
        .getStyle()
        .layers.filter(layer => layer.layout?.visibility)
        .forEach(({ id }) => {
          if (id.match(LAYER_ID_CMM)) {
            map.setLayoutProperty(id, 'visibility', 'visible')
            if (isFrenchSite) {
              map.on('click', id, handleClick)
            }
          }
        })

      return () => {
        if (map?.getStyle()) {
          map
            .getStyle()
            .layers.filter(layer => layer.layout?.visibility)
            .forEach(({ id }) => {
              if (isFrenchSite) {
                map.off('click', id, handleClick)
              }
            })
        }
      }
    },
    [status, isFrenchSite]
  )
}

export default useClickMyMapLayers
